import { Program } from '@/new-transport/_models/transport-map.model';

export const calculateParticipantsAmountFromPrograms = (programs: Program[]): number => {
	return programs.reduce((acc, program) => {
		acc += Array.from(program.reservation.values()).reduce((acc, slots) => acc + slots.length, 0);
		return acc;
	}, 0);
};
